var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallNotif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1V2.00474M6.0091 15.9034C7.99681 16.1269 10.0032 16.1269 11.9909 15.9034C11.9768 16.0967 11.9465 16.2887 11.9001 16.4772L11.8182 16.8106C11.5614 17.855 10.7455 18.6678 9.70388 18.917C9.2411 19.0277 8.7589 19.0277 8.29612 18.917C7.25451 18.6678 6.43863 17.855 6.18182 16.8106L6.09985 16.4772C6.0535 16.2887 6.02317 16.0967 6.0091 15.9034ZM3.0278 6.63259C3.58212 4.58674 5.15001 2.95325 7.15838 2.30223C8.39272 1.90211 9.73494 1.90145 10.9671 2.30838C12.9398 2.9599 14.45 4.57084 14.9793 6.58835L15.5625 8.81121L16.0298 10.9275C16.1737 11.5793 16.3696 12.2498 16.4728 12.9094C16.4907 13.0237 16.5 13.141 16.5 13.2604C16.5 14.3266 15.7525 15.2453 14.7124 15.4572L14.3448 15.532C10.8175 16.2506 7.18251 16.2506 3.65518 15.532L3.28759 15.4572C2.24755 15.2453 1.5 14.3266 1.5 13.2604C1.5 13.141 1.50929 13.0237 1.52719 12.9094C1.63043 12.2498 1.82626 11.5793 1.9702 10.9275L2.4375 8.81121L3.0278 6.63259Z",
    stroke: "#363853",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallNotif);
export default __webpack_public_path__ + "static/media/smallNotif.c03836ea367b4e1ccc62fc83aa6a2577.svg";
export { ForwardRef as ReactComponent };